/**
 *  Parse JWT token from backend size
 * @param token 
 * @returns 
 */
export function parseJwt(token: string): any {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
        window
            .atob(base64)
            .split("")
            .map(function (c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join(""),
    );

    return JSON.parse(jsonPayload);
}

export function getVSTTime(currentTime: Date) {
    const offset = 7; // UTC+7
    const utcOffsetInMilliseconds = offset * 60 * 60 * 1000;
    const currentTimeInUTCPlus7 = new Date(
        currentTime.getTime() + utcOffsetInMilliseconds
    );

    return currentTimeInUTCPlus7;
}

export function randomCode(length: number) {
    let result = "";
    const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
